<section class="filtros">
  <div class="filtros__form">
    <app-form [campos]="filtros" appearance="outline" #formFiltros></app-form>
  </div>

  <div class="filtros__actions">
    <button
      type="button"
      class="filtros__actions__button"
      matTooltip="Filtrar"
      (click)="onSubmit(formFiltros.form)"
      *ngIf="!esconderAcao"
    >
      <mat-icon>search</mat-icon>
    </button>

    <button
      type="button"
      class="filtros__actions__button"
      matTooltip="Limpar filtros"
      (click)="limparFiltros(formFiltros)"
      *ngIf="!esconderAcao"
    >
      <mat-icon>cleaning_services</mat-icon>
    </button>

    <ng-container *ngFor="let acao of acoes">
      <button
        type="button"
        class="filtros__actions__button"
        [matTooltip]="acao.tooltip"
        (click)="acao.action()"
        [disabled]="acao.disabled"
        *ngIf="!acao.hide"
      >
        <mat-icon>{{ acao.icon }}</mat-icon>
      </button>
    </ng-container>
  </div>
</section>
